
import makerjs from "makerjs";
function B11(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,S1 = Param[2].param, T = Param[3].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       s1 = S1 * 1 * myZoom,
       t = T * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = 0, x1 = s1, x2 =s1+t ,x3 =b , y0 = 0, y1 = l,y2 = l, y3 =0,glassH = l, glassW = b,h=l,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  } if (t !== 0) {
    var TxtT = "T="+T;
  } if (s1 !== 0) {
    var TxtS1 = "S1="+S1;
  }



   var drawAbnormalShapeB11 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine":new makerjs.paths.Line([x1,y1], [x2,y2]), 
        "RightLine":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "BottomLine": new makerjs.paths.Line([x3,y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeB11MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x0- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
        "RightShortDnline": new makerjs.paths.Line([x0, y1], [x0- 2 * markShift, y1]),
       }
   };
   var drawAbnormalShapeB11MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x3, y3- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB11MarkS1 = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y1+ markShift], [x1, y1+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y1], [x0, y1 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x1, y1], [x1, y1 + 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB11MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x1, y1+ markShift], [x2, y2+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x1, y1], [x1, y1 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB11MarkB, TxtB, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB11MarkL, TxtL, [x0-2*markShift, y0], [x0-2*markShift, y1]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB11MarkT, TxtT, [x1, y1+2*markShift], [x2, y2+2*markShift]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB11MarkS1, TxtS1, [x0, y1+2*markShift], [x1, y1+2*markShift]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeB11: drawAbnormalShapeB11,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB11: drawAbnormalShapeB11,
        drawAbnormalShapeB11MarkL: drawAbnormalShapeB11MarkL,
        drawAbnormalShapeB11MarkT: drawAbnormalShapeB11MarkT,
        drawAbnormalShapeB11MarkS1: drawAbnormalShapeB11MarkS1,
        drawAbnormalShapeB11MarkB:drawAbnormalShapeB11MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B11;